import axios from 'axios';

export const downloadFile = async (
  signedUrl: string,
  fileName: string
): Promise<void> => {
  const response = await axios.get(signedUrl, {
    method: 'GET',
    responseType: 'blob',
  });

  // Build URL and simulate user clicking on a hidden link for downloading the file
  const downloadUrl = window.URL.createObjectURL(
    new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), response.data], {
      type: 'text/csv;charset=utf-8;',
    })
  );
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
